import React, { useRef, useState, useEffect } from "react";
import { getApi } from '../../api/endpoints';
import uiManager from '../../../config/ui.js';
import UI_ACTIONS from '../../data/UiActionConstants.js';
import ListingComponent from '../../components/ListingComponent';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircle } from "@fortawesome/free-solid-svg-icons";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";
import UiAction from '../../components/UiAction.js';
import { useSelector, useDispatch } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import {
  updateQueryParams,
  selectQueryParams
} from "../../ui/customerListingReducer";
import Multiselect from "multiselect-react-dropdown";

const Listing = (props) => {
  const [pincodesApi] = getApi('pincodes');
  const [userPincodeMapApi] = getApi('createUserPincodeMap')
  const pincodeTextRef = useRef();
  const pincodeSelectRed = useRef();
  const defaultHeaderConfig = { disableSort: true };
  const [pincodes, setPincodes] = useState([]);
  const [ deleteMappingApi ] = getApi('deleteUserAreaMapping')
  const dispatch = useDispatch();
  const selectedQueryParams = useSelector(selectQueryParams)
  const navigate = useNavigate();
  const [toMapPincode, setToMapPincode] = useState([]);

  useEffect(()=>{
    console.log(props)
    getPincodesOptions({fields: "options", filters: {branch_ids: [props.branch_id || -1]}})
  }, [props])

  const getPincodesOptions = async (params) => {
    try{
      let response = await pincodesApi(params).unwrap();
      setPincodes(response.data.pincodes)
      // dispatch(updateQueryParams(selectedQueryParams));
    } catch(error) {
      toast.error(error.data.message || "Something went wrong while fetching pincodes.")
    }
  }

  const onDeleteClick = async (id) => {
    try{
      await deleteMappingApi({id: id}).unwrap();
      toast.success("User mapping removed from the area successfully.")
      dispatch(updateQueryParams(selectedQueryParams));
    } catch(error) {
      toast.error(error.data.message || "Something went wrong while deleting mappings.")
    }
  }

  const params = useParams();

  const headers = [
    {
      ...defaultHeaderConfig,
      label: 'ID',
      value: (row) => {
        return <>
          <span className='mx-2'>
            {row.is_valid || row.is_valid == null ? <FontAwesomeIcon icon={faCircle} className="text-success"/> : <FontAwesomeIcon icon={faCircle} className="text-danger"/>}
          </span>
          {row.id}
        </>
      },
      attr: 'id',
      disableSort: false
    },
    {
      ...defaultHeaderConfig,
      label: 'Pincode - Area',
      value: (row) => `${row.area.code} - ${row.area.area}`
    },
    {
      ...defaultHeaderConfig,
      label: 'Created At',
      attr: 'created_at',
      disableSort: false
    },
    {
      disableSort: true,
      label: 'Actions',
      value: (row) => {
        return <div style={{ display: 'flex', justifyContent: 'space-around' }}>
          <UiAction uiAction={uiManager.getUiAction(UI_ACTIONS.delete_area_user_mapping.name)}>
            <div style={{cursor: 'pointer'}} onClick={(e) => onDeleteClick(row.id) }>
              <FontAwesomeIcon icon={faTrash} className="text-danger"/>
            </div>
          </UiAction>
        </div>
      }
    }
  ];


  const makeDisticntPincodeObj = (all_pincodes) => {
    let set = new Set()
    let distinct_pincodes = all_pincodes.filter(pincode_obj => {
      if(!set.has(pincode_obj.pincode)) {
        set.add(pincode_obj.pincode);
        return true;
      }
      return false;
    })
    return distinct_pincodes
  }

  const getPincodes = async (params) => {
    try {
      let response = await pincodesApi(params).unwrap();
      let distinct_pincodes = makeDisticntPincodeObj(response.data.pincodes)
      setPincodes(distinct_pincodes);
    } catch (error) {
      toast.error(error?.data?.message || "Something went wrong while fetching pincodes.")
    }
  }

  const handleCancelFunction = () => {
    navigate('/manage_users');
  }

  const handleSubmitFunction = async (e) => {
    try {
      let response = {}
      if(pincodeTextRef.current.value != '') {
        let typedPincode = pincodeTextRef.current.value.replace(/\s/g, "").split(',');
        response = await userPincodeMapApi({
          user_id: params.id,
          pincodes: JSON.stringify(typedPincode),
          area_user_mappings: {user_id: params.id, company_id: 2, is_valid: true}
        }).unwrap();
      } else {
        response = await userPincodeMapApi({
          user_id: params.id,
          area_user_mappings: {user_id: params.id, pincode_id: toMapPincode, company_id: 2, is_valid: true}
        }).unwrap();
      }
      dispatch(updateQueryParams(selectedQueryParams));
      toast.success(response.message || "User mapped successfully!")
    } catch (error) {
      console.log(error)
      toast.error(error.data.message || "Something went wrong while mapping user.")
    }
    pincodeSelectRed.current.resetSelectedValues();
    pincodeTextRef.current.value = "";
  }

  const addPincode = (selectedList, selectedItem) => {
    setToMapPincode(selectedItem.id)
  }

  const removePincode = (selectedList ,removedItem) => {
    setToMapPincode((prevState)=>{
      return prevState.filter((item)=> item != removedItem.id);
    })
  }


  return <>
    <div className='container'>
      <div className='row p-3'>
        <div className='col'>
          <label>Select pincodes to map</label>
          <Multiselect
            options={pincodes}
            onSelect={addPincode}
            // onRemove={removePincode}
            displayValue="code"
            showArrow={true}
            customArrow={true}
            singleSelect={true}
            avoidHighlightFirstOption={true}
            ref={pincodeSelectRed}
          />
        </div>
        <div className="col text-center h5">OR</div>
        <div className='col'>
          <label htmlFor="pincodes_text">Type Comma Separated Pincodes</label>
          <textarea ref={pincodeTextRef} className="form-control" id="pincodes_text" name="pincodes_text"></textarea>
        </div>
      </div>
    </div>

    <div className='mb-4 col-md-12'>
      <button type="button" style={{ float: 'inline-start', width: '110px' }} className="btn btn-voltup-theme" onClick={handleCancelFunction}>
        Back
        </button>
      <button type="button" style={{ float: 'inline-end', width: '110px' }} className="btn btn-voltup-theme ms-3" onClick={handleSubmitFunction}>
        Submit
      </button>
    </div>
    <ListingComponent
      key={'PAGES.AreaUserMappingListingPage.name'}
      listingMutation={getApi('userPincodeMap')}
      className="area-user-mapping-listing"
      contentHeading="Area-User Mapping"
      headers={headers}
      recordsKey="area_user_mappings"
      params={{id: params.id}}
      searchBy={['ID', 'Pincode', 'Area']}
    />
  </>
};

export default Listing;
